/**
 * Target data
 */
const TARGET_DATA = {
  welcome: "welcome_data",
  anxiety: "anxiety_data",
  program: "program_data",
  webPayment: "web_payment_data",
  partnerPayment: "partner_payment_data",
};

const welcomeDataFields = [
  "choose_path",
  "choose_problem",
  "choose_phobias",
  "name_input",
  "age_select",
  "choose_gender",
  "choose_treatments",
];

const anxietyDataFields = ["choose_fears", "choose_feeling", "choose_comforts"];

const programDataFields = [];

export { TARGET_DATA, welcomeDataFields, programDataFields, anxietyDataFields };
